import { Web3Button } from "@web3modal/react";
import { useRef } from "react";
import styled from "styled-components";

const Wraper = styled.div`
  align-items: center;
  background-color: #131315;
  display: flex;
  height: 5.625rem;
  justify-content: center;
  max-width: 100%;
  position: sticky;
  top: 0px;
  width: 100%;
  z-index: 10;
  height: 6.5rem;

  h5 {
    font-family: "Poppins";
    font-style: normal;
    font-weight: 700;
    font-size: 42px;
    line-height: 140%;
    color: var(--polus_text_white);
    margin: 0;
  }
  svg {
    max-width: 232px;
  }
`;
const HeaderInner = styled.div`
  padding: 0 2.5rem;
  align-items: center;
  display: flex;
  justify-content: space-between;
  max-width: 87.5rem;
  padding: 0 1rem;
  width: 100%;
`;

export const Header = () => {
  return (
    <Wraper>
      <HeaderInner>
        <Web3Button />
      </HeaderInner>
    </Wraper>
  );
};
